/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Directory_Card_RatingInputs */

const en_directory_card_rating = /** @type {(inputs: Directory_Card_RatingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rating ${i?.value}`)
};

const zh_directory_card_rating = /** @type {(inputs: Directory_Card_RatingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`评分 ${i?.value}`)
};

/**
* | output |
* | --- |
* | "Rating {value}" |
*
* @param {Directory_Card_RatingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_rating = /** @type {((inputs: Directory_Card_RatingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_RatingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_rating(inputs)
	return zh_directory_card_rating(inputs)
});
export { directory_card_rating as "directory.card.rating" }